module.exports = __webpack_public_path__ + "static/media/mastercard-logo.33fccd20.svg";